import Cursor, {
  DevCursorType,
} from "game-engine/components/game-elements/Cursor";
import { Dimensions, GameConfigType, Position } from "game-engine/types";
import { Rect, Stage } from "react-konva";

import GAME_CONFIG from "game-files/gameConfig";
import PixelatedLayer from "../PixelatedLayer";
import styled from "styled-components";
import useCanvasDimensions from "game-engine/hooks/useCanvasDimensions";
import useGame from "game-engine/hooks/useGame";
import { useState } from "react";

const Wrapper = styled.div<{
  dimensions: Dimensions;
  showCursor: boolean;
  gameConfig: GameConfigType;
}>`
  width: ${(props) => props.dimensions.x}px;
  height: ${(props) => props.dimensions.y}px;
  overflow: hidden;
  cursor: ${(props) => (props.showCursor ? "auto" : "none")};
  filter: ${(props) => `blur(${props.gameConfig.render.blur}px)`};
`;

const Transform = styled.div<{ scale: Dimensions }>`
  transform-origin: 0 0;
  transform: scale(${(props) => props.scale.x}, ${(props) => props.scale.y});

  &,
  & > * {
    image-rendering: optimizeSpeed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: -o-crisp-edges;
    image-rendering: pixelated;
    -ms-interpolation-mode: nearest-neighbor;
  }
`;

const Canvas = (props: {
  onClick?: (options: {
    canvasPosition: Position;
    scenePosition: Position;
  }) => void;
  devCursor?: DevCursorType;
  noCursor?: boolean;
  children?: any;
}) => {
  const { onClick, devCursor, noCursor } = props;

  const { engineConfig, gameFns } = useGame();
  const [mouseOnCanvas, setMouseOnCanvas] = useState(false);

  const { dimensions, originalDimensions, scale } = useCanvasDimensions();

  //
  // CURSOR
  //
  const [cursor, setCursor] = useState<Position>({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setMouseOnCanvas(true);
    const position = e.target.getStage().getPointerPosition();
    setCursor({ x: Math.round(position.x), y: Math.round(position.y) });
  };

  //
  // RENDER
  //
  return (
    <Wrapper
      dimensions={dimensions}
      showCursor={engineConfig.state.renderBrowserCursor}
      gameConfig={GAME_CONFIG}
    >
      <Transform scale={scale}>
        <Stage
          width={originalDimensions.x}
          height={originalDimensions.y}
          onMouseMove={handleMouseMove}
          onMouseEnter={() => setMouseOnCanvas(true)}
          onMouseLeave={() => setMouseOnCanvas(false)}
        >
          {props.children}

          <PixelatedLayer>
            {!noCursor && mouseOnCanvas && (
              <Cursor position={cursor} devCursor={devCursor} />
            )}

            {onClick && (
              <Rect
                x={0}
                y={0}
                width={originalDimensions.x}
                height={originalDimensions.y}
                opacity={0}
                onClick={(e) =>
                  onClick({
                    canvasPosition: gameFns.getClickedPosition(e as any),
                    scenePosition: gameFns.getClickedScenePosition(e as any),
                  })
                }
              />
            )}
          </PixelatedLayer>
        </Stage>
      </Transform>
    </Wrapper>
  );
};

export default Canvas;
